"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const NavHeader_1 = require("@/common/components/NavHeader");
const functions_1 = require("@/common/functions");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
function default_1() {
    (0, NavHeader_1.hideNavHeaderOnMobile)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const isUpdate = window.location.pathname.includes('update');
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '56px',
            borderLeft: '1px solid #f8f8f8',
            borderRight: '1px solid #f8f8f8',
            backgroundColor: 'white',
            '> .MuiIconButton-root': {
                position: 'absolute',
                left: '12px',
            },
        } }, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: functions_1.goBackOrMain, sx: { position: 'absolute', left: '12px' } }, { children: (0, jsx_runtime_1.jsx)(svgs_1.HeaderBackSvg, {}) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ css: { fontSize: 17 } }, { children: isUpdate ? t('스토리 수정') : t('스토리 만들기') }))] })));
}
exports.default = default_1;
